var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, createRef } from 'react';
import { ButtonTheme, ModalType, Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, customFormatters, eventListener, expression, number, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, enumValues, isFunction, isTouchableDevice } from '@philips-internal/oswald-ui-utils';
import { Button } from '../button/button.js';
import { Modal } from '../modal/modal.js';
import { BarcodeAPI } from './barcode-api.js';
import { BarcodeReaderType } from './barcode-constants.js';
import { BarcodeContent } from './barcode-content.js';
let Barcode = class Barcode extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalType: ModalType.FULLSCREEN,
            open: false,
        };
        this.videoRef = createRef();
        this.onBarcodeButtonClick = () => {
            this.setState({ open: true });
        };
        this.onClose = () => {
            const { onClose } = this.props;
            this.setState({ open: false }, () => {
                if (isFunction(onClose)) {
                    onClose(new CloseEvent());
                }
            });
        };
        this.onReadTypeChange = (readerType) => {
            this.updateModalType(readerType);
        };
    }
    componentDidMount() {
        const { defaultReadType } = this.props;
        this.updateModalType(defaultReadType);
    }
    updateModalType(readerType) {
        if (isTouchableDevice()) {
            return this.setState({ modalType: ModalType.FULLSCREEN });
        }
        this.setState({
            modalType: readerType === BarcodeReaderType.CAMERA
                ? ModalType.FULLSCREEN
                : ModalType.DEFAULT,
        });
    }
    renderModal() {
        const { onBeforeClose } = this.props;
        const { open, modalType } = this.state;
        if (!open) {
            return null;
        }
        return (React.createElement(Modal, { className: "c-barcode-modal", closeable: true, focusOnOpen: false, noPadding: true, onBeforeClose: onBeforeClose, onClose: this.onClose, type: modalType },
            React.createElement(BarcodeContent, { ...this.props, onClose: this.onClose, onInfraredButtonSubmitClick: this.onClose, onManualButtonSubmitClick: this.onClose, onReadTypeChange: this.onReadTypeChange })));
    }
    render() {
        const { buttonTheme, enabled, openReaderExpression } = this.props;
        const className = classNames({
            'c-barcode': true,
            [`c-barcode--touchable-device`]: isTouchableDevice(),
        });
        return (React.createElement("div", { className: className },
            React.createElement(Button, { className: "c-barcode-modal-button", enabled: enabled, icon: "/static/assets/components/barcode.svg", iconPlacement: Placement.LEFT, onClick: this.onBarcodeButtonClick, theme: buttonTheme, value: openReaderExpression }),
            this.renderModal()));
    }
};
Barcode.propTypes = {
    buttonTheme: oneOf(enumValues(ButtonTheme)),
    cameraInputExpression: expression,
    cameraNotSupportedExpression: expression,
    cameraStripTopTitleExpression: expression,
    data: arrayOf(object).notEnumerable(),
    defaultReadType: oneOf(Object.values(BarcodeReaderType)),
    enabled: bool,
    formatters: customFormatters([' ', 'value']),
    hasDescription: bool,
    infraredInputExpression: expression,
    infraredNotSupportedExpression: expression,
    manualInputBarcodeExpression: expression,
    manualInputDescriptionExpression: expression,
    manualInputExpression: expression,
    manualInputMaxLength: number,
    manualInputReasonEmptyResultExpression: expression,
    manualInputReasonExpression: expression,
    manualInputReasonPlaceholderExpression: expression,
    manualInputSubmitexpression: expression,
    onBeforeClose: eventListener,
    onClose: eventListener,
    onReadFailure: eventListener,
    onReadSuccess: eventListener,
    openReaderExpression: expression,
    requireDescription: bool,
    requireReason: bool,
    supportCamera: bool,
    supportInfrared: bool,
    uuid: string,
};
Barcode.defaultProps = {
    buttonTheme: ButtonTheme.PRIMARY,
    cameraInputExpression: 'tws.barcode.camera-input',
    cameraNotSupportedExpression: 'tws.barcode.no-camera-support',
    cameraStripTopTitleExpression: 'tws.barcode.camera-strip-top-title',
    data: [],
    defaultReadType: BarcodeReaderType.MANUAL,
    enabled: true,
    hasDescription: true,
    infraredInputExpression: 'tws.barcode.infrared-input',
    infraredNotSupportedExpression: 'tws.barcode.no-infrared-support',
    manualInputBarcodeExpression: 'tws.barcode.manual-entry-code',
    manualInputDescriptionExpression: 'tws.barcode.manual-entry-description',
    manualInputExpression: 'tws.barcode.manual-input',
    manualInputReasonEmptyResultExpression: 'tws.not-found.results-not-found',
    manualInputReasonExpression: 'tws.barcode.manual-entry-reason',
    manualInputReasonPlaceholderExpression: '',
    manualInputSubmitExpression: 'tws.barcode.manual-submit',
    openReaderExpression: 'tws.barcode.open',
    requireDescription: true,
    requireReason: true,
    supportCamera: true,
    supportInfrared: false,
};
Barcode = __decorate([
    AwesomeComponent({ api: BarcodeAPI, type: ComponentType.DATA_ENTRY })
], Barcode);
export { Barcode, };
//# sourceMappingURL=barcode.js.map